import React, { useState, useRef, useEffect } from "react";
import useHttp from "../../hooks/use-http";
import { NavLink, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const [formData, setFormData] = useState({
    userName: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    userName: "",
    password: "",
  });

  const [otpError, setOtpError] = useState("");

  const [reotpError, setReOtpError] = useState("");

  const userNameInputRef = useRef();
  const passwordInputRef = useRef();

  const [otpChallenge, setOtpChallenge] = useState(false);
  const [otp, setOtp] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  const [isOtpVisible, setIsOtpVisible] = useState(false);
  const toggleOtpVisibility = () => {
    setIsOtpVisible((prev) => !prev);
  };

  const { sendRequest: putOTP } = useHttp();

  const [logErr, setLogErr] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [resendOtpCountdown, setResendOtpCountdown] = useState(0);
  const nav = useNavigate();

  useEffect(() => {
    if (resendOtpCountdown > 0) {
      const timer = setInterval(() => {
        setResendOtpCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [resendOtpCountdown]);

  const submitHandler = (event) => {
    setReOtpError("");
    event.preventDefault();
    if (validateForm()) {
      setLogErr("");

      const enteredUserName = userNameInputRef.current.value.trim();
      const enteredPassword = passwordInputRef.current.value.trim();

      // optional: Add validation

      setIsLoading(true);
      let url = `${process.env.REACT_APP_BASE_URL}/api/logInWeb/`;
      //console.log(url)
      fetch(url, {
        method: "POST",
        body: JSON.stringify({
          userName: enteredUserName,
          password: enteredPassword,
          returnSecureToken: true,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          setIsLoading(false);
          console.log(res);

          if (res.ok) {
            res.json().then((data) => {
              setOtpChallenge(data.id);
              setResendOtpCountdown(60);
            });
          } else {
            res.text().then((x) => {
              setLogErr(x);

              setIsLoading(false);
            });
          }
        })
        .catch((e) => {
          setLogErr("something went wrong");
          setIsLoading(false);
        });
    }
  };

  const { sendRequest: getServiceAllData } = useHttp();

  const serviceAllData = (userId) => {
    getServiceAllData(
      {
        url: `/api/serviceRoleAllocationByEmployee/?userId=${userId}`,
      },
      (data) => {
        localStorage.setItem("RoleAllocation", JSON.stringify(data));
      }
    );
  };

  const submitChallenge = (event) => {
    const inputOTP = otp;
    setReOtpError("");

    if (!inputOTP) {
      setOtpError("Please enter a valid OTP");

      return;
    } else {
      setOtpError("");
    }

    putOTP(
      {
        url: "/api/logInWeb/",
        method: "PUT",
        body: { id: otpChallenge, otp: inputOTP, useCase: "Warehouse" },
      },
      (data) => {
        console.log("Login Data", data);
        Cookies.set("token", data.Token);
        localStorage.setItem("token", data.Token);
        localStorage.setItem("attachmentFolder", data.attachmentFolder);

        localStorage.setItem("orgId", data.orgid);
        localStorage.setItem("id", data.userId);
        localStorage.setItem("userEmail", data.userEmail);
        localStorage.setItem("userContact", data.workContactNo);
        localStorage.setItem("orgCode", data.orgCode);

        localStorage.setItem("warehouseId", data.warehouseId);

        localStorage.setItem("organizationName", data.organizationName);
        localStorage.setItem("organizationAddress", data.organizationAddress);

        localStorage.setItem("organizationIcon", data.organizationIcon);

        localStorage.setItem("employeeName", data.employeeName);
        localStorage.setItem("useCase", data.useCase);
        localStorage.setItem("userIcon", data.userIcon);

        //Technical Setting
        localStorage.setItem("pageSize", 25);
        localStorage.setItem("decimalPattern", "^\\d*(\\.\\d{1,2})?$");
        localStorage.setItem("integerPattern", "^\\d*");
        localStorage.setItem("currencyCode", data.currency);
        localStorage.setItem("dateFormat", "dd/MM/yyyy");
        localStorage.setItem("empId", data.empId);
        serviceAllData(data.userId);

        nav("/");
      },

      (error) => {
        setOtpError(error);
      }
    );
  };

  //validation

  const validateForm = () => {
    let valid = true;
    setLogErr("");

    // console.log(formData);

    // Validate email
    if (!formData.userName) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        userName: "Please enter an user name",
      }));
      valid = false;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, userName: "" }));
    }

    // Validate password
    if (!formData.password) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: "Please provide a password",
      }));
      valid = false;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
    }

    return valid;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) =>
      type === "checkbox"
        ? { ...prevData, [name]: checked }
        : { ...prevData, [name]: value }
    );
  };

  useEffect(() => {
    const handleWindowClose = () => {
      Cookies.remove("token");
      localStorage.clear();
    };

    window.addEventListener("beforeunload", handleWindowClose);

    return () => {
      window.removeEventListener("beforeunload", handleWindowClose);
    };
  }, []);

  const handleResendOTP = (event) => {
    setOtpError("");
    event.preventDefault();

    const userId = otpChallenge;

    let url = `${process.env.REACT_APP_BASE_URL}/api/resendOtp/`;

    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        id: userId,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.ok) {
          res.json().then((data) => {
            console.log(data.message);
            toast.success(data.message || "Sent OTP to your email Id");
            setResendOtpCountdown(60);
          });
        } else {
          res.json().then((x) => {
            setReOtpError("Internal Server Error");
          });
        }
      })
      .catch((e) => {
        // console.log(e);
        setReOtpError("something went wrong");
        //alert("something went wrong")
      });
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        bodyClassName="toastBody"
      />
      <div className="login-wall hold-transition login-page">
        <div className="login-box">
          <div className="login-logo">
            <a href="/auth">
              <b>Sign In</b>
            </a>
          </div>

          <div className="card">
            <div className="card-body login-card-body">
              {!otpChallenge ? (
                <>
                  <p className="login-box-msg">
                    Enter your user name and password for signing in.
                  </p>
                  <form onSubmit={submitHandler} id="quickForm">
                    <div className="input-group mb-3">
                      {/* <input
                        type="text"
                        id="userName"
                        // required
                        name="userName" //
                        ref={userNameInputRef}
                        placeholder="User Name"
                        value={formData.userName}
                        onChange={handleChange}
                        className={`form-control ${
                          errors.userName ? "is-invalid" : ""
                        }`}
                      /> */}

                      <input
                        type="text"
                        id="userName"
                        name="userName"
                        ref={userNameInputRef}
                        placeholder="User Name"
                        value={formData.userName}
                        onChange={handleChange}
                        className={`form-control ${errors.userName ? "is-invalid" : ""}`}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            passwordInputRef.current?.focus(); // 👈 jump to password
                          }
                        }}
                      />


                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span className="fas fa-user" />
                        </div>
                      </div>
                      {errors.userName && (
                        <span className="invalid-feedback">
                          {errors.userName}
                        </span>
                      )}
                    </div>
                    <div className="input-group mb-3">
                      {/* <input
                        type={isPasswordVisible ? "text" : "password"}
                        placeholder="Password"
                        id="password"
                        name="password"
                        autoComplete="off"
                        //  required
                        ref={passwordInputRef}
                        value={formData.password}
                        onChange={handleChange}
                        className={`form-control ${errors.password ? "is-invalid" : ""
                          }`}
                      /> */}

                      <input
                        type={isPasswordVisible ? "text" : "password"}
                        placeholder="Password"
                        id="password"
                        name="password"
                        autoComplete="off"
                        ref={passwordInputRef}
                        value={formData.password}
                        onChange={handleChange}
                        className={`form-control ${errors.password ? "is-invalid" : ""}`}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            document.getElementById("quickForm").requestSubmit(); // 👈 triggers your form submit
                          }
                        }}
                      />


                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span
                            className={`fas ${isPasswordVisible ? "fa-eye-slash" : "fa-eye"
                              }`}
                            onClick={togglePasswordVisibility}
                          />
                        </div>
                      </div>
                      {errors.password && (
                        <span className="invalid-feedback">
                          {errors.password}
                        </span>
                      )}
                    </div>
                    {logErr && (
                      <>
                        <span className="text-danger mb-2">{logErr}</span>
                        <br />
                      </>
                    )}
                    {isLoading ? (
                      <>
                        {" "}
                        <div className="text-center">
                          <i className="fas fa-3x fa-sync-alt fa-spin"></i>
                          <div className="text-bold pt-2">Loading...</div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="row">
                          <div className="col-4">
                            <button
                              type="submit"
                              className="btn btn-primary btn-block"
                            >
                              Next
                            </button>
                          </div>
                          {/* /.col */}
                        </div>
                      </>
                    )}
                  </form>

                  <p className="mb-1">
                    <NavLink to="/forgotpassword">I forgot my password</NavLink>
                  </p>
                </>
              ) : (
                <>
                  <p className="login-box-msg">
                    Please enter the OTP sent to your email address.
                  </p>
                  <form>
                    <div className="input-group mb-3">
                      {/* <input
                        type={isOtpVisible ? "text" : "password"}
                        id="otp"
                        placeholder="OTP"
                        required
                        autoComplete="off"
                        defaultValue=" "
                        className={`form-control ${otpError ? "is-invalid" : ""
                          }`}
                        value={otp}
                        onChange={(e) => {
                          setOtp(e.target.value);
                        }}
                      /> */}

                      <input
                        type={isOtpVisible ? "text" : "password"}
                        id="otp"
                        placeholder="OTP"
                        required
                        autoComplete="off"
                        className={`form-control ${otpError ? "is-invalid" : ""}`}
                        value={otp}
                        onChange={(e) => {
                          setOtp(e.target.value);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();   
                            submitChallenge();    
                          }
                        }}
                      />


                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span
                            className={`fas ${isOtpVisible ? "fa-eye-slash" : "fa-eye"
                              }`}
                            onClick={toggleOtpVisibility}
                          />
                        </div>
                      </div>

                      {otpError && (
                        <div className="invalid-feedback">{otpError}</div>
                      )}
                      {reotpError && (
                        <div className="invalid-feedback">{reotpError}</div>
                      )}
                    </div>

                    <div className="row">
                      <p className="col-md-4">
                        <NavLink
                          onClick={handleResendOTP}
                          disabled={resendOtpCountdown > 0}
                          style={{
                            pointerEvents:
                              resendOtpCountdown > 0 ? "none" : "auto",
                            color: resendOtpCountdown > 0 ? "grey" : "blue",
                          }}
                        >
                          Resend OTP{" "}
                          {resendOtpCountdown > 0 && `(${resendOtpCountdown}s)`}
                        </NavLink>
                      </p>
                      <div className="col-4">
                        <button
                          type="button"
                          onClick={submitChallenge}
                          className="btn btn-primary btn-block"
                        >
                          Submit
                        </button>
                      </div>
                      <div className="col-4">
                        <button
                          type="button"
                          className="btn btn-success btn-block"
                          onClick={() => setOtpChallenge(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
